import PokerTablePokerBase from "./poker_table_poker_base";
import PokerTableSeatPokers from "./poker_seat_pokers_base"
const { ccclass, property, menu } = cc._decorator;


@ccclass
@menu("custom/PokerTableMySeatPokers")
export default class PokerTableMySeatPokers extends PokerTableSeatPokers{
    
    @property(cc.Boolean)
    useDynamicOffset: boolean = false

    @property(cc.Vec2)
    minOffset: cc.Vec2 = cc.Vec2.ZERO

    @property(cc.Vec2)
    maxOffset: cc.Vec2 = cc.Vec2.ZERO

    isPlayingSelectPokerAnim: boolean = false    

    protected mFirstHoverPoker: PokerTablePokerBase = null
    protected mLastHoverPoker: PokerTablePokerBase = null

    private m_sortedByZIndexPokerList: PokerTablePokerBase[] = []
    private m_selectTimeIndex: number = 0

    protected custom_on_finish_drag_pokers_fun: Function = null    
    protected on_finish_drag_pokers_reselect_fun: Function = null
    protected on_select_pokers_changed: Function = null
    
    @property(cc.Vec2)
    selectOffest: cc.Vec2 = cc.v2(0, 30)

    protected m_originalInterval: cc.Vec2 = null

    getOriginalInterval(): cc.Vec2{
        return this.m_originalInterval
    }

    protected getIntervalX(totalColCount: number, totalRowCount: number): number{
        let intervalX = super.getIntervalX(totalColCount, totalRowCount)
        if(this.useDynamicOffset){
            if(totalColCount > 1){
                let dis = this.getOriginalInterval().x * (this.maxColCount - 1)
                intervalX = dis / (totalColCount - 1)
                intervalX = Math.max(this.minOffset.x, intervalX)
                intervalX = Math.min(this.maxOffset.x, intervalX)
            }            
        }
        return intervalX
    }

    protected getIntervalY(totalColCount: number, totalRowCount: number): number{
        let intervalY = super.getIntervalY(totalColCount, totalRowCount)
        if(this.useDynamicOffset){
            if(totalRowCount > 1){
                let dis = this.getOriginalInterval().y * (this.maxRowCount - 1)
                intervalY = dis / (totalRowCount - 1)
                intervalY = Math.max(this.minOffset.y, intervalY)
                intervalY = Math.min(this.maxOffset.y, intervalY)
            }            
        }
        return intervalY
    }


    onLoad(){
        this.m_originalInterval = cc.v2(this.intervalX, this.intervalX)
    }

    protected getSelectedOffsetPos(): cc.Vec2{
        return this.selectOffest
    }

    protected genTimeSelectIndex(){
        return ++this.m_selectTimeIndex
    }

    private genSortedByZIndexPokerList(){
        let pokers = this.pokers    
        let newList = []    
        for (let index = 0; index < this.pokers.length; index++) {            
            newList.push(pokers[index])
        }
        newList.sort(function(a, b){
            return b.node.zIndex - a.node.zIndex
        })
        return newList
    }

    private findTouchedPoker(touch: cc.Touch): PokerTablePokerBase{
        let sortedByZIndexPokerList = this.m_sortedByZIndexPokerList
        for (let index = 0; index < sortedByZIndexPokerList.length; index++) {
            const element = sortedByZIndexPokerList[index]
            if(element.isTouchAtPoker(touch)){
                return element              
            }
        }
        return null
    }

    protected genPoker(code: number, params?: any){
        let poker = super.genPoker(code, params)
        poker.setClickListener(this.on_click, this)
        poker.setTouchStartListener(this.on_touch_start, this)
        poker.setTouchMoveListener(this.on_touch_move, this)
        poker.setTouchEndListener(this.on_touch_end, this)
        poker.setTouchCancelListener(this.on_touch_cancel, this)
        return poker
    }

    protected on_touch_start(poker: PokerTablePokerBase, event: cc.Event.EventTouch){        
        this.m_sortedByZIndexPokerList = this.genSortedByZIndexPokerList()
        if(this.isPlayingSelectPokerAnim){
            return
        }
        this.on_press(poker, event)     
    }

    protected on_touch_move(poker: PokerTablePokerBase, event: cc.Event.EventTouch){    
        if(this.isPlayingSelectPokerAnim){
            return
        }
        let touchedPoker = this.findTouchedPoker(event.touch)
        !touchedPoker && this.on_drag_empty()
        if(touchedPoker != null){
            this.on_drag(touchedPoker, event)
        }
    }

    protected on_touch_end(poker: PokerTablePokerBase, event: cc.Event.EventTouch){
        if(this.isPlayingSelectPokerAnim){
            return
        }
        this.on_press_up(poker, event)
    }

    protected on_touch_cancel(poker: PokerTablePokerBase, event: cc.Event.EventTouch){
        if(this.isPlayingSelectPokerAnim){
            return
        }
        let touchedPoker = this.findTouchedPoker(event.touch)
        !touchedPoker && this.on_drag_empty()
        if(touchedPoker != null){
            this.on_press_up(touchedPoker, event)
        }else{
            this.on_press_up(this.mFirstHoverPoker, event)            
        }
    }

    protected on_drag_empty(){

    }

    protected on_click(poker: PokerTablePokerBase){

    }

    protected on_drag(poker: PokerTablePokerBase, event?: cc.Event.EventTouch){
        if(this.mFirstHoverPoker == null){
            this.mFirstHoverPoker = poker
        }
        this.mLastHoverPoker = poker
        this.on_draging_pokers()
    }

    protected on_press(poker: PokerTablePokerBase, event?: cc.Event.EventTouch){
        this.mFirstHoverPoker = poker
        this.mLastHoverPoker = poker
        this.on_draging_pokers()
    }

    protected on_press_up(poker: PokerTablePokerBase, event?: cc.Event.EventTouch){
        if(poker != null){
            if(this.mFirstHoverPoker == null){
                this.mFirstHoverPoker = poker
            }
            if(this.mLastHoverPoker == null){
                this.mLastHoverPoker = poker
            }
        }else{
            
        }
        if(this.mLastHoverPoker != null){
            this.on_draging_pokers()
            this.on_finish_drag_pokers()
        }
    }

    protected check_drag_mark(){
        let opt = {
            startPoker: null,
            isLeftPokersUnMark: false,
        }
        let pokers = this.pokers
        for (let i = 0; i < pokers.length; i++) {
            const poker = pokers[i];
            opt = this.check_drag_mark_singel(poker, opt.isLeftPokersUnMark, opt.startPoker)
        }
    }

    protected check_drag_mark_singel(poker: PokerTablePokerBase, isLeftPokersUnMark: boolean, startPoker: PokerTablePokerBase): 
    {isLeftPokersUnMark: boolean, startPoker: PokerTablePokerBase}{
        if(isLeftPokersUnMark){
            poker.marked = false
        }else{
            if(poker == this.mFirstHoverPoker){
                poker.marked = true
                if(startPoker != null || poker == this.mLastHoverPoker){
                    isLeftPokersUnMark = true
                }else{
                    startPoker = poker
                }
            }else if(poker == this.mLastHoverPoker){
                poker.marked = true
                if(startPoker != null || poker == this.mFirstHoverPoker){
                    isLeftPokersUnMark = true
                }else{
                    startPoker = poker
                }
            }else{
                if(startPoker != null){
                    poker.marked = true
                }else{
                    poker.marked = false
                }
            }
        }
        return {isLeftPokersUnMark: isLeftPokersUnMark, startPoker: startPoker}
    }

    protected check_poker_selected_state():{markedList: PokerTablePokerBase[], selectedList: PokerTablePokerBase[],  real_selectedList: PokerTablePokerBase[]}{
        let markedList = []
        let selectedList = []
        let real_selectedList = []
        let pokers = this.pokers
        for (let i = 0; i < pokers.length; i++) {
            const poker = pokers[i]    
            if(poker.marked && (!poker.disabled)){
                poker.selected = !poker.selected
                markedList.push(poker)
                if(poker.selected){
                    selectedList.push(poker)
                    poker.selected_time = this.genTimeSelectIndex()
                }else{
                    poker.selected_time = 0
                }
                if(poker.real_selected){
                    real_selectedList.push(poker)
                }
            }
        }
        return {markedList: markedList, selectedList: selectedList, real_selectedList: real_selectedList}
    }

    protected on_draging_pokers(){
        this.check_drag_mark()
        this.refreshPokersMarkState()
    }

    protected on_finish_drag_pokers(){
        let self = this
        this.mFirstHoverPoker = null
        this.mLastHoverPoker = null
        let opt = this.check_poker_selected_state()
        this.markAllPokers(false)
        this.refreshPokersMarkState()
        if(this.custom_on_finish_drag_pokers_fun != null){
            return this.custom_on_finish_drag_pokers_fun()
        }
        if(opt.markedList.length > 1 && opt.selectedList.length > 1 && this.on_finish_drag_pokers_reselect_fun){
            this.on_finish_drag_pokers_reselect_fun()
        }else{
            this.isPlayingSelectPokerAnim = true
            this.refreshPokerSelectState(true, function(){
                self.isPlayingSelectPokerAnim = false
            })
        }
    }

    protected markAllPokers(isMark: boolean){
        let pokers = this.pokers
        for (let i = 0; i < pokers.length; i++) {
            const poker = pokers[i];
            poker.marked = isMark        
        }
    }

    protected refreshPokersMarkState(){
        let pokers = this.pokers
        for (let i = 0; i < pokers.length; i++) {
            const poker = pokers[i];
            this.setPokerGrayColor(poker, poker.marked)
        }
    }

    protected setPokerGrayColor(poker: PokerTablePokerBase, gray: boolean){
        if(gray){
            poker.spriteFace.node.color = cc.color(128, 128, 128, 255)
        }else{
            poker.spriteFace.node.color = poker.original_color
        }
    }

    protected playSelectPokerAnim(node: cc.Node, original_pos: cc.Vec2, selected: boolean, withAnim: boolean, onFinish: Function){     
        withAnim = false                
        let selectedOffsetPos = this.getSelectedOffsetPos()
        let targetPos = cc.v2(original_pos.x, original_pos.y)
        if(selected){
            targetPos.y += selectedOffsetPos.y
        }        
        if(withAnim){
            let duration = 0.1
            let callFun = cc.callFunc(function(){
                if(onFinish){
                    onFinish()
                }
            }.bind(this))
            var move = cc.moveTo(duration, targetPos)
            var seq = cc.sequence([move, callFun]);
            node.runAction(seq);
        }else{
            node.position = targetPos
            if(onFinish != null){
                onFinish()
            }
        }
    }

    refreshPokerSelectState(withAnim: boolean, onFinish?: Function){
        withAnim = false
        let self = this
        let pokers = this.pokers
        let finishCount = 0
        const totalCount = pokers.length
        for (let i = 0; i < totalCount; i++) {
            const poker = pokers[i];
            let selected = poker.selected
            this.playSelectPokerAnim(poker.node, poker.original_pos, selected, withAnim, function(){
                if(selected){
                    poker.real_selected = true
                    poker.real_selected_time = self.genTimeSelectIndex()
                }else{
                    poker.real_selected = false
                    poker.real_selected_time = 0
                }
                finishCount += 1
                if(finishCount == totalCount){
                    if(onFinish){
                        onFinish()
                    }
                    if(self.on_select_pokers_changed){
                        self.on_select_pokers_changed()
                    }
                }
            })
        }
    }

    setCustomOnFinishDragFunc(callback: Function){
        this.custom_on_finish_drag_pokers_fun = callback
    }

    setCustomOnFinishDragPokerReselectFunc(callback: Function){
        this.on_finish_drag_pokers_reselect_fun = callback
    }

    setCustomOnSelectPokersChanged(callback: Function){
        this.on_select_pokers_changed = callback
    }

    resetPokers(withAnim?: boolean, onFinish?: Function, params?: any){
        withAnim = false
        let self = this
        this.selectAllPokers(false)
        this.refreshPokersMarkState()

        if(params){
            if(params.ignoreResetDisable){

            }else{
                this.enabledAllPokers()
                this.refreshPokerDisableState()
            }
        }else{
            this.enabledAllPokers()
            this.refreshPokerDisableState()
        }

        if(withAnim){
            this.isPlayingSelectPokerAnim = true
        }
        this.repostionPokers(withAnim, function(){
            self.isPlayingSelectPokerAnim = false
            if(onFinish){
                onFinish()
            }
            if(self.on_select_pokers_changed){
                self.on_select_pokers_changed()
            }
        })
    }

    repostionPokers(withAnim: boolean, onFinish?: Function){
        withAnim = false
        let pokers = this.pokers
        let duration = 0.2
        let totalCount = pokers.length
        let layoutData = this.calcLayoutPosAndPriority(totalCount)
        let dataList = layoutData.dataList
        let finishCount = 0
        for (let i = 0; i < totalCount; i++) {
            let poker = pokers[i];          
            let data = dataList[i]  
            if(withAnim){
                poker.original_pos = data.pos
                let moveAnim = cc.moveTo(duration, data.pos)
                let callFun = cc.callFunc(function(){
                    poker.node.zIndex = data.priority
                    finishCount++
                    if(finishCount == totalCount){
                        if(onFinish){
                            onFinish()
                        }
                    }
                })
                let seq = cc.sequence([moveAnim, callFun])
                poker.node.runAction(seq)
            }else{
                poker.node.position = data.pos
                poker.original_pos = data.pos
                poker.node.zIndex = data.priority 
            }            
        }
        if(!withAnim){
            if(onFinish){
                onFinish()
            }
        }
    }

    selectPokers(codeList: number[], idList: number[]){
        let selectPokers = []
        let waitSelectedCodeCountTable = []
        let selectedCodeCountTable = []
        let pokers = this.pokers
        let useIdFind = false
        let tmpList = codeList
        if(idList && idList.length > 0){
            useIdFind = true
            tmpList = idList
        }
        for (let i = 0; i < tmpList.length; i++) {
            const index = tmpList[i];
            if(!waitSelectedCodeCountTable[index]){
                waitSelectedCodeCountTable[index] = 0
            }
            waitSelectedCodeCountTable[index] = waitSelectedCodeCountTable[index] + 1
            selectedCodeCountTable[index] = 0
        }
        this.selectAllPokers(false)
        for (let i = 0; i < tmpList.length; i++) {
            let index = tmpList[i]
            for (let j = 0; j < pokers.length; j++) {
                const poker = pokers[j];
                let pokerIndex = poker.code
                if(useIdFind){
                    pokerIndex = poker.id
                }
                if(pokerIndex == index && (!poker.selected)){
                    if(waitSelectedCodeCountTable[index] > selectedCodeCountTable[index]){
                        selectedCodeCountTable[index] = selectedCodeCountTable[index] + 1
                        poker.selected = true
                        poker.selected_time = this.genTimeSelectIndex()
                        selectPokers.push(poker)
                    }
                }
            }
        }
        return selectPokers
    }

    selectPoker(poker: PokerTablePokerBase, select: boolean){
        if(select){
            poker.selected = true
            poker.selected_time = this.genTimeSelectIndex()
            poker.real_selected = true
            poker.real_selected_time = this.genTimeSelectIndex()
        }else{
            poker.selected = false
            poker.selected_time = 0
            poker.real_selected = false
            poker.real_selected_time = 0
        }
        poker.marked = false
    }

    selectAllPokers(isSelect: boolean){
        let pokers = this.pokers
        for (let i = 0; i < pokers.length; i++) {
            const poker = pokers[i];
            this.selectPoker(poker, isSelect)
        }
    }


    getSelectedPokers(){
        let selected_pokerList: PokerTablePokerBase[] = []
        let selected_idList: number[] = []
        let selected_codeList: number[] = []

        let real_selected_pokerList: PokerTablePokerBase[] = []
        let real_selected_idList: number[] = []
        let real_selected_codeList: number[] = []
        let pokers = this.pokers
        for (let i = 0; i < pokers.length; i++) {
            const poker = pokers[i];
            if(poker.selected){
                selected_pokerList.push(poker)
                selected_idList.push(poker.id)
                selected_codeList.push(poker.code)
            }

            if(poker.real_selected){
                real_selected_pokerList.push(poker)
                real_selected_idList.push(poker.id)
                real_selected_codeList.push(poker.code)
            }
        }
        return {
            selected_pokerList: selected_pokerList,
            selected_codeList: selected_codeList,
            selected_idList: selected_idList,
            real_selected_pokerList: real_selected_pokerList,
            real_selected_codeList: real_selected_codeList,
            real_selected_idList: real_selected_idList,
        }
    }

    enabledAllPokers(){
        let enabledPokers = []
        let pokers = this.pokers
        for (let i = 0; i < pokers.length; i++) {
            const poker = pokers[i];
            poker.disabled = false
            enabledPokers.push(poker)
        }
        return enabledPokers
    }

    disablePokers(codeList: number[], idList?: number[]){
        let disabledPokers = []
        let waitdisabledCodeCountTable = []
        let disabledCodeCountTable = []
        let pokers = this.pokers
        let useIdFind = false
        let tmpList = codeList
        if(idList && idList.length > 0){
            useIdFind = true
            tmpList = idList
        }
        for (let i = 0; i < tmpList.length; i++) {
            const index = tmpList[i];
            if(!waitdisabledCodeCountTable[index]){
                waitdisabledCodeCountTable[index] = 0
            }
            waitdisabledCodeCountTable[index] = waitdisabledCodeCountTable[index] + 1
            disabledCodeCountTable[index] = 0
        }
        this.enabledAllPokers()
        for (let i = 0; i < tmpList.length; i++) {
            let index = tmpList[i]
            for (let j = 0; j < pokers.length; j++) {
                const poker = pokers[j];
                let pokerIndex = poker.code
                if(useIdFind){
                    pokerIndex = poker.id
                }
                if(pokerIndex == index && (!poker.disabled)){
                    if(waitdisabledCodeCountTable[index] > disabledCodeCountTable[index]){
                        disabledCodeCountTable[index] = disabledCodeCountTable[index] + 1
                        poker.disabled = true
                        disabledPokers.push(poker)
                    }
                }
            }
        }
        return disabledPokers
    }

    refreshPokerDisableState(){
        let pokers = this.pokers
        for (let i = 0; i < pokers.length; i++) {
            const poker = pokers[i];
            poker.enableClick(!poker.disabled)
        }
    }



}
